import { createRoot } from 'react-dom/client'
import './index.css'

function forceFavicon(url: string) {
  const rels = ['icon', 'shortcut icon', 'apple-touch-icon']
  rels.forEach((rel) => {
    let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
    if (!link) {
      link = document.createElement('link')
      link.rel = rel
      document.head.appendChild(link)
    }
    link.href = url
  })
}

forceFavicon('/assets/appicon_popup.png?v=5')

function showLoadError(message: string) {
  const root = document.getElementById('root')
  if (!root) return
  root.innerHTML = [
    '<div style="padding:24px;font-family:system-ui,sans-serif;max-width:480px;margin:0 auto;">',
    '<h2 style="margin:0 0 12px 0;color:#c00;">App failed to load</h2>',
    '<p style="margin:0 0 8px 0;color:#333;">' + message.replace(/</g, '&lt;') + '</p>',
    '<p style="margin:0;font-size:14px;color:#666;">Set these in your deployment environment (Vercel, Netlify, etc.) and rebuild. See .env.example.</p>',
    '</div>',
  ].join('')
}

import('./App')
  .then(({ default: App }) => {
    createRoot(document.getElementById('root')!).render(<App />)
  })
  .catch((err: Error) => {
    console.error('[App load error]', err)
    showLoadError(err?.message ?? 'Unknown error')
  })
